import * as React from 'react';

import ConnectedModal from 'containers/ConnectedModal';
import SaveCustomCaptionStyleUpsellModalContents from './SaveCustomCaptionStyleUpsellModalContents';
import { block } from './utils';

export interface SaveCustomCaptionStyleUpsellModalProps {}

const SaveCustomCaptionStyleUpsellModal: React.FC<SaveCustomCaptionStyleUpsellModalProps> = () => (
  <ConnectedModal
    name="SaveCustomCaptionStyleUpsell"
    title="Save Custom Caption Style"
    className={block()}
  >
    <SaveCustomCaptionStyleUpsellModalContents />
  </ConnectedModal>
);

export default SaveCustomCaptionStyleUpsellModal;
